export { default as ThingsMapWidget } from "./things_map_widget_container";
import * as ThingsMapWidgetFactory from "./things_map_widget_factory";
export { default as WidgetEditThingsMap } from "./things_map_widget_form";

export { ThingsMapWidgetFactory };
